import clsx from 'clsx'
import Link from 'next/link'
import { FC } from 'react'

import { TSection } from '@/shared/types/deprecated-types'

import cls from './subcategory-chips.module.scss'

export type SubcategoryChipsProps = {
	className?: string
	items: TSection[]
}

// Shown in place of the guided filter for categories that have no filters at all (empty PROPERTIES,
// e.g. «Красота и здоровье»): the subcategories become the page's navigation, rendered as link chips
// that match the look of the step-filter value chips.
export const SubcategoryChips: FC<SubcategoryChipsProps> = ({ className, items }) => {
	// Same visibility rule as CategoriesGrid: drop empty sections and ones flagged hidden.
	const visibleItems = items.filter(item => item.COUNT !== `0` && !item.UF_DONT_SHOW_IN_LIST)

	if (!visibleItems.length) return null

	return (
		<nav className={clsx(cls.root, className)} aria-label="Подразделы">
			{visibleItems.map(item => (
				<Link key={item.code} href={`/catalog/${item.code}`} prefetch={false} scroll={false} className={cls.chip}>
					{item.title}
				</Link>
			))}
		</nav>
	)
}
